import React from 'react';

import { flagStyles } from '../settings';

const SvgCI = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1008px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCI;
